import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["overrides", "use"];
import I18n from 'I18n';
import { useMemo } from 'react';
import BaseRoutingRules from 'routing-ui/routing-rules/components/RoutingRules';
import { checkChannelAssignsToAvailable } from '../utils/channels';
import { jsx as _jsx } from "react/jsx-runtime";
export const RoutingRules = _ref => {
  let {
      overrides: overridesProp,
      use
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const overrides = useMemo(() => {
    if (checkChannelAssignsToAvailable(use)) {
      return Object.assign({}, overridesProp, {
        routingTypeSelect: Object.assign({}, overridesProp === null || overridesProp === void 0 ? void 0 : overridesProp.routingTypeSelect, {
          options: {
            anyUser: I18n.text('conversations-routing-lib.routing-rules.options.anyAvailableUser')
          }
        })
      });
    }
    return overridesProp;
  }, [overridesProp, use]);
  return /*#__PURE__*/_jsx(BaseRoutingRules, Object.assign({}, props, {
    overrides: overrides,
    use: use
  }));
};
RoutingRules.displayName = 'CvRoutingRules';
export default RoutingRules;